import React, { useEffect, useState } from "react";
import "./ToastBanner.scss";

export const ToastBanner = ({ title, duration }) => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(false);
    }, duration);

    return () => clearTimeout(timer);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="toast-banner-container toast-banner-danger">
      <strong>{title}</strong>{" "}
      <button
        type="button"
        className="close-toast-banner"
        onClick={() => {
          setIsOpen(false);
        }}
      >
        ×
      </button>
      &nbsp;<span></span>
    </div>
  );
};
